<template>
  <div class="user-wrp-comments mydorm-galeri">
    <file-upload
      class="btn btn-primary"
      post-action="/upload/post"
      extensions="gif,jpg,jpeg,png,webp"
      accept="image/png,image/gif,image/jpeg,image/webp"
      :multiple="true"
      :size="1024 * 1024 * 10"
      v-model="gallery"
      @input-filter="inputFilter"
      @input-file="inputFile"
      ref="gallery1"
    >
      <i class="fa fa-plus"></i>
      Resim Seç
    </file-upload>
    <div class="galeri-wrp">
      <div class="row">
        <div class="col-xs-12 col-md-8 galeri-left">
          <div class="galeri-left-wrp">
            <div
              class="galeri-left__item"
              :class="{ active: item.isActive }"
              v-for="item in gallery"
              :key="item.id"
              @click="doActive(item, index)"
            >
              <img class="galeri-left__item-img" :src="item.filename" alt="" />
            </div>
          </div>
        </div>
        <!--         <div class="col-xs-12 col-md-4 galeri-right">
          <div class="galeri-right-wrp">
            <div class="galeri-right__box">
                    <input
                      type="file"
                      class="form-control custom-input"
                      ref="gallery"
                      multiple
                      @change="handleImages"
                    >
              <span class="galeri-right__icon">
              <svg-icon type="icon-gallery"/>
           </span>
            </div>
          </div>
        </div> -->
      </div>
      <div class="galeri-wrp__bottom">
        Seçilen Kapak Fotoğrafı
      </div>
    </div>
    <modal
      :active="showModal"
      modal-class="modal-gallery"
      @onModalClose="closeGallery"
    >
      <div slot="content">
        <transition-group tag="div" class="modal-gallery__list" name="fade">
          <draggable v-model="gallery">
            <transition-group>
              <div
                v-for="(img, index) in gallery"
                :key="img.id"
                class="modal-gallery__item"
                :class="{ active: index === currentItem }"
                v-show="index === currentItem"
              >
                <img :src="img.filename" alt="" class="modal-gallery__img" />
              </div>
            </transition-group>
          </draggable>
        </transition-group>
        <v-button
          class="green modal-gallery__button prev"
          icon="icon-arrow-left"
          icon-position="left"
          @click.native="prevItem"
        />
        <v-button
          class="green modal-gallery__button next"
          icon="icon-arrow-right"
          icon-position="left"
          @click.native="nextItem"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import draggable from 'vuedraggable'
export default {
  name: 'MyDormGaleri2',
  components: {
    FileUpload,
    draggable
  },
  props: {
    gallery: Array
  },
  data() {
    return {
      currentItem: null,
      showMmodal: false,
      isActive: false
    }
  },
  methods: {
    openGallery(index) {
      this.showModal = true
      this.currentItem = index
    },
    closeGallery() {
      this.showModal = false
    },
    prevItem() {
      if (this.currentItem > 0) {
        this.currentItem--
      } else {
        this.currentItem = this.gallery.length - 1
      }
    },
    nextItem() {
      if (this.currentItem < this.gallery.length - 1) {
        this.currentItem++
      } else {
        this.currentItem = 0
      }
    },
    doActive(item) {
      let index = 0
      this.gallery.forEach(img => {
        if (item.id === img.id) {
          this.currentItem = index
        }
        index++
        item.isActive = false
      })
      console.log('select kapak')
      item.isActive = true
      this.showModal = true
      // this.currentItem = index
      // this.isActive = !this.isActive
    },
    handleImages(e) {
      let selectedFlies = e.target.files
      if (!selectedFlies.length) {
        return false
      }
      for (let i = 0; i < selectedFlies.length; i++) {
        this.gallery.push(selectedFlies[i])
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/components/mydorm-galeri';
</style>
